<template>
  <loan-status-alert-container :loan="loan" borrower-action-required>
    <template #borrower>
      <p>
        {{ $t("components.loan.status.alerts.accepted.borrower.message") }}
      </p>
    </template>

    <template #owner>
      <p>
        {{
          $t("components.loan.status.alerts.accepted.owner.message", {
            name: loan.borrower_user.name,
          })
        }}
      </p>
      <p v-if="loan.loanable.type === 'car'">
        {{
          $t("components.loan.status.alerts.accepted.owner.car_warning", {
            name: loan.borrower_user.name,
          })
        }}
      </p>
    </template>

    <template #admin>
      <p>
        {{
          $t("components.loan.status.alerts.accepted.admin.message", {
            name: loan.borrower_user.name,
          })
        }}
      </p>
    </template>
  </loan-status-alert-container>
</template>

<script>
import LoanStatusAlertContainer from "@/components/Loan/Status/Alerts/LoanStatusAlertContainer.vue";
import { sections } from "@/components/Loan/FullLoanSections";

export default {
  name: "LoanAccepted",
  components: {
    LoanStatusAlertContainer,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sections,
    };
  },
};
</script>

<style lang="scss"></style>
